// import {
//   CollisionComponent,
//   Component,
//   Type,
//   Object3D,
// } from "@wonderlandengine/api";
// import { Cursor, CursorTarget } from "@wonderlandengine/components";
// // ✅ 正确代码
// import { PeerManager } from "./networking.js";

// export class NetworkButtons extends Component {
//   static TypeName = "network-buttons";
//   static Properties = {
//     peerManagerObject: { type: Type.Object },
//     cursor: { type: Type.Object },
//     hostButton: { type: Type.Object },
//     joinButton: { type: Type.Object },
//   };

//   /** @type {Object3D} */
//   peerManagerObject;

//   start() {
//     this.pm = this.peerManagerObject.getComponent(PeerManager);

//     /* If hostButton or joinButton are not specified, we search
//      * for them by name */
//     for (let c of this.object.children) {
//       if (c.name == "HostButton") this.hostButton = this.hostButton || c;
//       if (c.name == "JoinButton") this.joinButton = this.joinButton || c;
//     }

//     this.hostButtonCollider = this.hostButton.getComponent(CollisionComponent);
//     this.hostButton
//       .getComponent(CursorTarget)
//       .addClickFunction(this.pm.host.bind(this.pm));

//     this.joinButtonCollider = this.joinButton.getComponent(CollisionComponent);
//     this.joinButton
//       .getComponent(CursorTarget)
//       .addClickFunction(this.pm.join.bind(this.pm));

//     this.pm.addConnectionEstablishedCallback(this.hide.bind(this));
//     this.pm.addDisconnectCallback(this.show.bind(this));
//   }

//   show() {
//     if (this.cursor.getComponent(Cursor).setEnabled)
//       this.cursor.getComponent(Cursor).setEnabled(true);
//     this.hostButtonCollider.active = true;
//     this.joinButtonCollider.active = true;
//     this.object.setPositionLocal([0, 0, -3]);
//   }

//   hide() {
//     /* Old versions of the cursor component don't have the setEnabled function */
//     if (this.cursor.getComponent(Cursor).setEnabled)
//       this.cursor.getComponent(Cursor).setEnabled(false);
//     this.hostButtonCollider.active = false;
//     this.joinButtonCollider.active = false;
//     this.object.setPositionLocal([0, -300, 0]);
//   }
// }
import { Component, Type } from "@wonderlandengine/api";
import {
  addStablePointerSelect,
  ensureInteractable,
} from "./interactable.js";

const BUTTON_HITBOX_EXTENTS = [0.18, 0.18, 0.18];

export class NetworkButtons extends Component {
  static TypeName = "network-buttons";
  static Properties = {
    // 绑定按钮物体
    peerManagerObject: { type: Type.Object },
    hostButton: { type: Type.Object },
    joinButton: { type: Type.Object },
    muteButton: { type: Type.Object },
    muteLabel: { type: Type.Object },
    tutorialPlayPauseButton: { type: Type.Object },
    tutorialReplayButton: { type: Type.Object },
    tutorialPlayPauseLabel: { type: Type.Object },
    // 绑定整个容器（连接成功后用来隐藏按钮）
    container: { type: Type.Object },
  };

  start() {
    console.log("🖱️ Buttons initialized");

    // 1. 设置 Host 按钮点击事件
    if (this.hostButton) {
      this.setupButton(this.hostButton, "host");
    } else {
      console.warn("⚠️ HostButton not assigned in Editor!");
    }

    // 2. 设置 Join 按钮点击事件
    if (this.joinButton) {
      this.setupButton(this.joinButton, "join");
    } else {
      console.warn("⚠️ JoinButton not assigned in Editor!");
    }

    if (this.muteButton) {
      this.setupButton(this.muteButton, "mute");
      this.updateMuteLabel(false);
    }

    if (this.tutorialPlayPauseButton) {
      this.setupButton(this.tutorialPlayPauseButton, "tutorial-toggle");
      this.updateTutorialPlayPauseLabel(true);
    }

    if (this.tutorialReplayButton) {
      this.setupButton(this.tutorialReplayButton, "tutorial-replay");
    }
  }

  setupButton(obj, type) {
    const { target } = ensureInteractable(obj, {
      extents: BUTTON_HITBOX_EXTENTS,
    });

    // 确保物体上有 CursorTarget 组件 (用于接收点击)
    // 绑定点击按下事件 (新版 API)
    addStablePointerSelect(target, () => {
      console.log(`🖱️ Clicked: ${type}`);

      // 播放一个简单的点击动画（变小一点点）
      const originalScale = [1, 1, 1];
      obj.getScalingLocal(originalScale);
      obj.setScalingLocal(originalScale.map((value) => value * 0.94));
      setTimeout(() => obj.setScalingLocal(originalScale), 100);

      // 调用核心逻辑
      this.triggerAction(type);
    });
  }

  getPeerManager() {
    const boundManager = this.peerManagerObject?.getComponent("peer-manager");
    if (boundManager) return boundManager;

    if (typeof window !== "undefined" && window.peerManager) {
      console.warn(
        "[network-buttons] peerManagerObject is not assigned. Falling back to window.peerManager.",
      );
      return window.peerManager;
    }

    return null;
  }

  triggerAction(type) {
    const manager = this.getPeerManager();

    if (!manager) {
      console.error(
        "[network-buttons] PeerManager was not found. Assign peerManagerObject in the Editor."
      );
      return;
    }

    if (type === "mute") {
      const muted = manager.toggleMute();
      this.updateMuteLabel(muted);
      return;
    }

    if (type === "tutorial-toggle") {
      const playing = manager.toggleTutorialVideo();
      this.updateTutorialPlayPauseLabel(playing);
      return;
    }

    if (type === "tutorial-replay") {
      manager.replayTutorialVideo();
      this.updateTutorialPlayPauseLabel(true);
      return;
    }

    if (type === "host") {
      manager.host();
    } else {
      manager.join();
    }

    // 点击后隐藏按钮，防止重复点击
    if (this.muteButton) {
      this.hostButton.active = false;
      this.joinButton.active = false;
    } else if (this.container) {
      // 把按钮移到地底下去 (隐藏)
      this.container.setPositionWorld([0, -100, 0]);
    } else {
      // 如果没绑定容器，就隐藏按钮自己
      this.hostButton.active = false;
      this.joinButton.active = false;
    }
  }

  updateMuteLabel(muted) {
    if (!this.muteLabel) return;
    const text = this.muteLabel.getComponent("text");
    if (text) text.text = muted ? "Unmute" : "Mute";
  }

  updateTutorialPlayPauseLabel(playing) {
    if (!this.tutorialPlayPauseLabel) return;
    const text = this.tutorialPlayPauseLabel.getComponent("text");
    if (text) text.text = playing ? "Pause" : "Play";
  }
}
